import { createAsyncThunk } from '@reduxjs/toolkit'
import { IFormPartners } from 'legacy/lut/classes/models/IFormPartners'
import { selectCountries } from 'legacy/lut/selectors/app'

import { IPartner } from 'clickNgo/entities/partner/models'
import { EPartnersCrud } from 'onboarding/api/OnboardingPartnerApi'
import { IFetchPartnerParams } from 'onboarding/features/models'
import { mapPartnerOrChangeRequestFromCrud } from 'onboarding/services/mapping/mapPartnerOrChangeRequestFromCrud'
import { partnerService } from 'onboarding/services/partnerService'
import { mapPhoneCodeToCountryCode } from 'onboarding/utils/country'

import {
  GET_ONBOARDING_NEW_PARTNER_BY_ID_REQUEST,
  GET_ONBOARDING_PARTNER_BY_ID_REQUEST,
} from '../config'

class PartnerThunks {
  private mapFromDB = (item: IFormPartners, state: any) => {
    return mapPartnerOrChangeRequestFromCrud(
      item,
      mapPhoneCodeToCountryCode(selectCountries(state))
    )
  }

  public fetchOneByPartnerId = createAsyncThunk(
    GET_ONBOARDING_PARTNER_BY_ID_REQUEST,
    async ({ partnerId }: IFetchPartnerParams, thunkAPI): Promise<IPartner | null> => {
      const state: any = thunkAPI.getState()
      const item = await partnerService.fetchOneByPartnerId(partnerId, {
        crudKey: EPartnersCrud.partnerDataForm,
      })

      return item ? this.mapFromDB(item, state) : null
    }
  )

  public fetchChangeRequestByPartnerId = createAsyncThunk(
    GET_ONBOARDING_NEW_PARTNER_BY_ID_REQUEST,
    async ({ partnerId }: IFetchPartnerParams, thunkAPI): Promise<IPartner | null> => {
      const state: any = thunkAPI.getState()
      const item = await partnerService.fetchChangeRequestByPartnerId(partnerId, {
        crudKey: EPartnersCrud.partnerDataForm,
        sort: [{ field: 'EntryId', dir: 'desc' }],
      })

      return item ? this.mapFromDB(item, state) : null
    }
  )
}

export const partnerThunks = new PartnerThunks()
